module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, NOVEMBER 10, 1953")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, FEBRUARY 19, 1954")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, FEBRUARY 13, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 23, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JUNE 7, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, OCTOBER 14, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, OCTOBER 15, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, OCTOBER 28, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, DECEMBER 3, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, DECEMBER 7, 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JANUARY 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JANUARY 26, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 8, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, APRIL 16, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, MAY 6, 1956 TO THURSDAY, MAY 10, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, JUNE 17, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, JULY 22, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, AUGUST 17, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, NOVEMBER 15, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY DECEMBER 30, 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, JANUARY 9, 1956 TO MONDAY, JANUARY 23, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JANUARY 22, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, FEBRUARY 24, 1957 & MONDAY, FEBRUARY 25, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, MARCH 19, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MAY 11, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, MAY 16, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, MAY 20, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, MAY 27, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, MAY 29, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JUNE 29, 1957 TO MONDAY, JULY 1, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JULY 16, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JULY 23, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, JULY 28, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, AUGUST 2, 1957 TO AUGUST 22, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, AUGUST 26, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, AUGUST 30, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, SEPTEMBER 6, 1957 TO SUNDAY, NOVEMBER 24, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, SEPTEMBER 21, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, SEPTEMBER 23, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY SEPTEMBER 28, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, NOVEMBER 2, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, NOVEMBER 27, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, NOVEMBER 24, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, NOVEMBER 29, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, DECEMBER 1, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, DECEMBER 4, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, DECEMBER 26, 1957 TO MONDAY, JANUARY 6, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, DECEMBER 28, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, JANUARY 8, 1958 TO FRIDAY, JANUARY 24, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 18, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 25, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, JANUARY 26, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, JANUARY 27, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JANUARY 30, 1958 TO WEDNESDAY, FEBRUARY 5, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 1, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 5, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, FEBRUARY 9, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 12, 1958 & THURSDAY, FEBRUARY 13, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, FEBRUARY 20, 1958 TO TUESDAY, FEBRUARY 25, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, FEBRUARY 28, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MARCH 1, 1958 TO TUESDAY, MARCH 25, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, MARCH 2, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, MARCH 14, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MARCH 15, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, MARCH 28, 1958 TO FRIDAY, MAY 9, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 5, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 19, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MAY 3, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, MAY 25, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, JUNE 6 & SATURDAY JUNE 7, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, JUNE 9, 1958 TO WEDNESDAY, JUNE 18, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JUNE 14, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JUNE 19, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, JULY 4, 1958 TO SUNDAY, JULY 13, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JULY 22, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 2, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 9, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, AUGUST 11, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, AUGUST 15, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, AUGUST 17, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 23, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 30, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, SEPTEMBER 10, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, SEPTEMBER 30, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, OCTOBER 2, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, OCTOBER 3, 1958 TO SUNDAY, OCTOBER 19, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, OCTOBER 21, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, OCTOBER 28, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, NOVEMBER 3, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, DECEMBER 3, 1958 TO WEDNESDAY, DECEMBER 17,1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, DECEMBER 11, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, DECEMBER 14, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, DECEMBER 27, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JANUARY 1, 1959 TO MONDAY, JANUARY 19, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 17, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JANUARY 22, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, JANUARY 23, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 24, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 31, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, FEBRUARY 1, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, FEBRUARY 2, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, FEBRUARY 3, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 4, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, FEBRUARY 5, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 7, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 4, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 11, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 25, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MAY 9, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 1, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, OCTOBER 3, 1959")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 16, 1960")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MAY 7, 1960")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 11, 1961")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEPTEMBER, 1961")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, NOVEMBER 4, 1961")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARCH, 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MARCH 17, 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 4, 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, SEPTEMBER 29, 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 12, 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 16, 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 13, 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, SEPTEMBER 28, 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 11, 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 1, 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, SEPTEMBER 19, 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, OCTOBER 18, 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JULY 3, 1965")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, FEBRUARY 3, 1967")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 13, 1968")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, APRIL 12, 1969")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, DECEMBER 24, 1969")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JANUARY 15, 1972")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JULY 26, 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEPTEMBER, 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, SEPTEMBER 7, 1976")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MARCH 25, 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, MAY 18, 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 26, 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, SEPTEMBER 7, 1978 TO THURSDAY, SEPTEMBER 14, 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 3, 1979")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, MARCH 13, 1979")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, SEPTEMBER 14, 1979")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 27, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, SEPTEMBER 5, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JUNE 2, 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, AUGUST 15, 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, SEPTEMBER 8, 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JANUARY 23, 1986")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, MARCH 3, 1986")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, JULY 24, 1987")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, SEPTEMBER 7, 1988")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, DECEMBER 24, 1988")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, OCTOBER 12, 1989")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, FEBRUARY 8, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, JUNE 23, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, SEPTEMBER 4, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, OCTOBER 23, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, JULY 12, 1992")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 20, 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, SEPTEMBER 7, 1995")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, JANUARY 2, 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, DECEMBER 19, 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 26, 1997")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, APRIL 9, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, AUGUST 28, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, SEPTEMBER 3, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, FEBRUARY 13, 2002")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, SEPTEMBER 20, 2005")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIDAY, AUGUST 3, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, FEBRUARY 14, 2009")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_chap1#d173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, JUNE 17, 2010")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03736764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_contents.vue
// module id = 60
// module chunks = 0